import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';

import App from './App';
import { HashRouter } from 'react-router-dom';


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

ReactDOM.render(<HashRouter><App /></HashRouter>, document.getElementById('root')); 